import { render } from "./GreenLink.vue?vue&type=template&id=8a08065e"
import script from "./GreenLink.vue?vue&type=script&lang=js"
export * from "./GreenLink.vue?vue&type=script&lang=js"

import "./GreenLink.vue?vue&type=style&index=0&id=8a08065e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__